import { render, staticRenderFns } from "./gdpr.component.vue?vue&type=template&id=7365397e&"
import script from "./gdpr.component.vue?vue&type=script&lang=ts&"
export * from "./gdpr.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gdpr.component.vue"
export default component.exports